import { render } from "./Chargement.vue?vue&type=template&id=1bf01adf&scoped=true"
const script = {}

import "./Chargement.vue?vue&type=style&index=0&id=1bf01adf&scoped=true&lang=css"

import exportComponent from "C:\\Git_repos\\blendify\\blendify-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bf01adf"]])

export default __exports__